import Httpconfig, { retailerAuthToken } from '../components/helpers/HttpconfigRetailer';
import Constant from '../constants';
import axios from 'axios';

class RetailerUploadService {
  /**
   * Save column mapping for retailer
   */
  static async saveColumnMapping(retailerId, mapping) {
    return await Httpconfig.httptokenpost(
      `${Constant.siteurl}api/OM/retailerProduct/column-mapping`,
      { retailer_id: retailerId, mapping }
    );
  }

  /**
   * Get saved column mapping for retailer
   */
  static async getColumnMapping(retailerId) {
    return await Httpconfig.httptokenget(
      `${Constant.siteurl}api/OM/retailerProduct/column-mapping/${retailerId}`
    );
  }

  /**
   * Validate and match products
   */
  static async validateAndMatchProducts(products, useFlaskAI = false) {
    console.log(`[API] Calling validate-match-products with ${products.length} products`);
    
    return await Httpconfig.httptokenpost(
      `${Constant.siteurl}api/OM/retailerProduct/validate-match-products`,
      { products, useFlaskAI }
    );
  }

  /**
   * Validate single product with external API
   */
  static async validateWithExternalAPI(productName, manufacturer = '', strength = '') {
    return await Httpconfig.httptokenpost(
      `${Constant.siteurl}api/OM/retailerProduct/validate-external`,
      { productName, manufacturer, strength }
    );
  }

  /**
   * Upload mapped stock to retailer
   */
  static async uploadMappedStock(retailerId, products) {
    return await Httpconfig.httptokenpost(
      `${Constant.siteurl}api/OM/retailerProduct/upload-mapped-stock`,
      { retailer_id: retailerId, products }
    );
  }

  /**
   * Export unmapped products to Excel for admin processing
   */
  static async exportUnmappedToExcel(products, retailerId) {
    // Use axios directly to handle blob response
    return await axios.post(
      `${Constant.siteurl}api/OM/retailerProduct/v3/export-unmapped`,
      { unmappedProducts: products, retailerId: retailerId },
      {
        headers: {
          'Authorization': retailerAuthToken()
        },
        responseType: 'arraybuffer' // Important: Handle binary data correctly
      }
    );
  }

  /**
   * Email unmapped products to admin
   */
  static async emailUnmappedToAdmin(data) {
    return await Httpconfig.httptokenpost(
      `${Constant.siteurl}api/OM/retailerProduct/email-unmapped-to-admin`,
      data
    );
  }

  /**
   * Submit unmapped products for admin approval
   */
  static async submitForApproval(data) {
    return await Httpconfig.httptokenpost(
      `${Constant.siteurl}api/product-approvals/submit`,
      { 
        retailer_id: data.retailerId, 
        unmapped_products: data.unmappedProducts 
      }
    );
  }
}

export default RetailerUploadService;
